import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-chaxun",
  "use": "icon-chaxun-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-chaxun\"><defs><style type=\"text/css\"></style></defs><path d=\"M724.173722 608.066299m33.939704 33.939705l203.638226 203.638225q33.939704 33.939704 0 67.879409l0 0q-33.939704 33.939704-67.879409 0l-203.638225-203.638226q-33.939704-33.939704 0-67.879408l0 0q33.939704-33.939704 67.879408 0Z\" p-id=\"5777\" /><path d=\"M48.436376 928.00402m47.99799 0l287.98794 0q47.99799 0 47.99799 47.99799l0 0q0 47.99799-47.99799 47.99799l-287.98794 0q-47.99799 0-47.99799-47.99799l0 0q0-47.99799 47.99799-47.99799Z\" p-id=\"5778\" /><path d=\"M464.418957 832.00804a415.982581 415.982581 0 1 1 293.747699-121.594909A415.342608 415.342608 0 0 1 464.418957 832.00804z m0-735.969182A319.986601 319.986601 0 1 0 688.409577 192.034839a319.986601 319.986601 0 0 0-223.99062-95.995981z\" p-id=\"5779\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-chaxun.svg
// module id = zVcx
// module chunks = 120